import React from 'react';

import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';
import type { MenuSection } from 'src/gql/graphql';
import { useRecentlyViewedCarousel } from './use-recently-viewed-carousel';

export type RecentlyViewedCarouselProps = {
  section?: MenuSection;
  sectionIndex?: number;
  excludeProductId?: string;
};

export function RecentlyViewedCarousel(props: RecentlyViewedCarouselProps): JSX.Element | null {
  const { section, excludeProductId } = props;
  const label = `Recently Viewed`;

  const carouselProps = useRecentlyViewedCarousel({
    excludeProductId,
  });
  const { products, loading } = carouselProps;

  if (!loading && !products.length) {
    return null;
  }

  return <ProductCarouselV2 products={products} isLoading={loading} title={section?.label ?? label} />;
}
